import React from 'react';
import { Newsletter } from '../components/Newsletter';
import { Countdown } from '../components/Countdown';

export const NewsletterPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-950 via-black to-gray-900 pt-24">
      <div className="container mx-auto px-4 lg:px-8 py-8">
        <Countdown />
      </div>
      {/* Hero Image */}
      <div className="container mx-auto px-4 lg:px-8 pb-4">
        <div className="max-w-5xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden ring-1 ring-gold-500/30 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.7)]">
            <img
              alt="Brooksgordon in the studio — suited, mic and mixing console in view"
              className="w-full h-auto object-cover max-h-[520px] object-top"
              loading="lazy"
              src="https://customer-assets.emergentagent.com/job_d063d7a9-eda0-44cf-9fcf-715c92eeba27/artifacts/9ndt9ztt_1782956788931%281%29.png"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10">
              <div className="flex items-center gap-3 mb-2">
                <div className="h-px w-10 bg-gold-500"></div>
                <span className="text-gold-400 uppercase tracking-[0.3em] text-xs font-semibold">Stay In The Loop</span>
              </div>
              <h1 className="text-3xl md:text-5xl font-bold text-teal-50 leading-tight max-w-2xl">
                Be the first to hear what's next.
              </h1>
              <p className="text-teal-200 text-base md:text-lg mt-3 max-w-xl">
                Release drops, show announcements, and early access — straight from the studio to your inbox.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Newsletter />
    </div>
  );
};